import { useEffect, useRef, useState } from "react";
import { adminApi } from "../lib/adminAuth";

const FIELDS = [
  { key: "nombre", label: "Nombre", type: "text" },
  { key: "foto_url", label: "URL foto (o ruta /api/files/…)", type: "text" },
  { key: "twitter_url", label: "URL Twitter", type: "url" },
  { key: "instagram_url", label: "URL Instagram", type: "url" },
  { key: "github_url", label: "URL GitHub", type: "url" },
  { key: "rss_url", label: "URL RSS", type: "url" },
];

export default function PanelPerfil() {
  const [form, setForm] = useState({
    nombre: "", bio: "", foto_url: "",
    twitter_url: "", instagram_url: "", github_url: "", rss_url: "",
  });
  const [toast, setToast] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  useEffect(() => {
    adminApi.get("/config/author").then((r) => setForm({ ...form, ...r.data }));
    // eslint-disable-next-line
  }, []);

  const showToast = (m, t = "ok") => { setToast({ m, t }); setTimeout(() => setToast(null), 2400); };

  const submit = async (e) => {
    e.preventDefault();
    try {
      await adminApi.put("/admin/config/author", form);
      showToast("Perfil actualizado");
    } catch {
      showToast("No se pudo guardar", "error");
    }
  };

  const onPickFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = ""; // allow re-selecting the same file
    if (!file) return;
    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
      showToast("Formato no admitido (jpg, png o webp)", "error");
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      showToast("Máximo 2 MB", "error");
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await adminApi.post("/admin/upload/foto", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setForm((f) => ({ ...f, foto_url: r.data.url }));
      showToast("Foto subida");
    } catch (err) {
      showToast(err?.response?.data?.detail || "Error al subir", "error");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid="panel-perfil">
      <div className="panel-eyebrow">Autor</div>
      <h1>Perfil</h1>

      <div className="panel-card" style={{ marginTop: 24, maxWidth: 720 }}>
        <form onSubmit={submit} data-testid="perfil-form">
          {form.foto_url && (
            <div style={{ marginBottom: 16 }}>
              <img
                src={form.foto_url}
                alt={form.nombre}
                style={{ width: 96, height: 96, borderRadius: "50%", objectFit: "cover" }}
                data-testid="perfil-foto-preview"
              />
            </div>
          )}
          <div style={{ marginBottom: 16, display: "flex", gap: 8, flexWrap: "wrap" }}>
            <input
              ref={fileRef}
              type="file"
              accept="image/jpeg,image/png,image/webp"
              onChange={onPickFile}
              style={{ display: "none" }}
              data-testid="perfil-foto-file"
            />
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => fileRef.current?.click()}
              disabled={uploading}
              data-testid="perfil-foto-upload-btn"
            >
              {uploading ? "Subiendo…" : "Subir nueva foto"}
            </button>
            <span style={{ fontFamily: "var(--font-display)", fontSize: "0.78rem", color: "var(--ink-3)", alignSelf: "center" }}>
              jpg · png · webp · máx 2 MB
            </span>
          </div>
          {FIELDS.map((f) => (
            <div key={f.key} style={{ marginBottom: 12 }}>
              <label style={{ display: "block", fontFamily: "var(--font-display)", fontSize: "0.78rem", color: "var(--ink-3)", marginBottom: 4, letterSpacing: "0.06em", textTransform: "uppercase" }}>
                {f.label}
              </label>
              <input
                type={f.type}
                value={form[f.key] || ""}
                onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                data-testid={`perfil-${f.key}`}
                style={{ width: "100%", padding: "10px 12px", border: "1px solid var(--border-md)", borderRadius: "var(--radius)", background: "var(--bg)", fontFamily: "var(--font-body)", fontWeight: 300 }}
              />
            </div>
          ))}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontFamily: "var(--font-display)", fontSize: "0.78rem", color: "var(--ink-3)", marginBottom: 4, letterSpacing: "0.06em", textTransform: "uppercase" }}>
              Bio
            </label>
            <textarea
              value={form.bio || ""}
              onChange={(e) => setForm({ ...form, bio: e.target.value })}
              data-testid="perfil-bio"
              style={{ width: "100%", minHeight: 120, padding: "10px 12px", border: "1px solid var(--border-md)", borderRadius: "var(--radius)", background: "var(--bg)", fontFamily: "var(--font-body)", fontWeight: 300, resize: "vertical" }}
            />
          </div>
          <button type="submit" className="btn btn-primary btn-sm" data-testid="perfil-submit">
            Guardar perfil
          </button>
        </form>
      </div>

      {toast && <div className={`toast ${toast.t === "error" ? "error" : ""}`}>{toast.m}</div>}
    </div>
  );
}
